import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const FaultValues = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default FaultValues;
